import { render, staticRenderFns } from "./PositionsReportComponent.vue?vue&type=template&id=49cce654&scoped=true"
import script from "./PositionsReportComponent.js?vue&type=script&lang=js&external"
export * from "./PositionsReportComponent.js?vue&type=script&lang=js&external"
import style0 from "./PositionsReportComponent.vue?vue&type=style&index=0&id=49cce654&prod&lang=scss&scoped=true"
import style1 from "./PositionsReportComponent.vue?vue&type=style&index=1&id=49cce654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cce654",
  null
  
)

export default component.exports